export const GET_WIDGET = 'GET_WIDGET';
export const GET_WIDGET_REQUEST = 'GET_WIDGET_REQUEST';
export const GET_WIDGET_SUCCESS = 'GET_WIDGET_SUCCESS';
export const GET_WIDGET_ERROR = 'GET_WIDGET_ERROR';

export const EDIT_WIDGET_REQUEST = 'EDIT_WIDGET_REQUEST';
export const EDIT_WIDGET_SUCCESS = 'EDIT_WIDGET_SUCCESS';
export const EDIT_WIDGET_ERROR = 'EDIT_WIDGET_ERROR';
